import React from 'react';
import PropTypes from 'prop-types';
// Styles centralized in AdminStyles.css

/**
 * Reusable page layout component with consistent header and content structure
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {string} [props.description] - Page description
 * @param {React.ReactNode} [props.actions] - Action buttons/content in header
 * @param {React.ReactNode} [props.filters] - Filter bar component
 * @param {React.ReactNode} props.children - Page content
 * @param {string} [props.className] - Additional CSS classes
 */
const PageLayout = ({
  title,
  description,
  actions,
  filters,
  children,
  className = ''
}) => {
  return (
    <div className={`page-layout ${className}`}>
      <div className="page-header">
        <div className="page-header-content">
          <div>
            <h1 className="page-title">{title}</h1>
            {description && <p className="page-description">{description}</p>}
          </div>
          {actions && <div className="page-header-actions">{actions}</div>}
        </div>
      </div>
      
      {filters && <div className="page-filters">{filters}</div>}
      
      <div className="page-content">
        {children}
      </div>
    </div>
  );
};

PageLayout.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
  filters: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default PageLayout;

